export function withBody(body: Record<string, string | number | boolean | undefined | string[] | number[]> | FormData | Object, options: RequestInit) {
  if (body instanceof FormData) {
    options.body = body;
  } else {
    options.body = JSON.stringify(body);
    if (!options.headers) {
      options.headers = {};
    }
    options.headers["Content-Type"] = "application/json";
  }
}
